export const setLineHeight = ({ lineHeight }) =>
  lineHeight ? { lineHeight } : {};
